var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCohereIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_753_4550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12.7497V12.7497H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_753_4550)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.13067 7.59123C4.47386 7.59123 5.15649 7.5724 6.10011 7.18391C7.19959 6.73122 9.3872 5.90939 10.9653 5.06529C12.069 4.47491 12.5528 3.69403 12.5528 2.64248C12.5528 1.18309 11.3697 0 9.91031 0H3.79557C1.69946 0 0 1.69938 0 3.79565C0 5.89184 1.59108 7.59123 4.13067 7.59123Z",
    fill: "#39594D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16504 10.2042C5.16504 9.70172 5.31396 9.21051 5.59299 8.79262C5.87201 8.37473 6.26862 8.04891 6.73272 7.85631L8.65837 7.05713C10.6061 6.24873 12.75 7.68014 12.75 9.78908C12.75 11.4229 11.4253 12.7473 9.79137 12.7469L7.7065 12.7463C6.30276 12.746 5.16504 11.6079 5.16504 10.2042Z",
    fill: "#D18EE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.18807 8.0918C0.979549 8.0918 0 9.07135 0 10.2798V10.5632C0 11.7716 0.979624 12.7512 2.18799 12.7512C3.39644 12.7512 4.37606 11.7716 4.37606 10.5632V10.2798C4.37606 9.07135 3.39644 8.0918 2.18807 8.0918Z",
    fill: "#FF7759"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohereIcon);
export default __webpack_public_path__ + "static/media/cohere-icon.e93ee6dd78635febdfd3eb97945e499f.svg";
export { ForwardRef as ReactComponent };